import { FACILITATIONS } from "./facilitations";
import { FINANCE } from "./finance";
import { LINKS } from "./links";
import { SERVICES } from "./services";

export const MENU = [
  {
    title: "Home",
    link: LINKS.HOME,
  },
  {
    title: "Bandi e Cumulabilitá",
    link: LINKS.BUILD_YOUR_SOLUTION,
  },
  {
    title: "Finanza Agevolata",
    id: "finance",
    subMenuOptions: [
      {
        title: "Finanza Agevolata",
        link: LINKS.FINANCE,
      },
    ].concat(
      Object.keys(FINANCE).map((key) => {
        return {
          title: FINANCE[key].title,
          link: FINANCE[key].button.link,
        };
      })
    ),
  },
  {
    title: "Agevolazioni in evidenza",
    id: "facilitations",
    subMenuOptions: Object.keys(FACILITATIONS).map((key) => {
      return {
        title: FACILITATIONS[key].title,
        link: FACILITATIONS[key].button.link,
      };
    }),
  },
  {
    title: "Servizi",
    id: "services",
    subMenuOptions: Object.keys(SERVICES).map((key) => {
      return {
        title: SERVICES[key].title,
        link: SERVICES[key].button.link,
      };
    }),
  },
  {
    title: "Chi siamo",
    link: LINKS.ABOUT,
  },
  {
    title: "Partners",
    link: LINKS.PARTNERS,
  },
  {
    title: "Contatti",
    link: LINKS.CONTACTS,
  },
];
